import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageType } from 'enums/MessageType';
import { environment } from 'environments/environment';
import { MailTemplateModel } from 'models/generated/Communication.Api.Models.MailTemplate';
import { firstValueFrom } from 'rxjs';
import { PushService } from 'services/push.service';

@Injectable()
export class MailService {

	private baseUrl = `${environment.gatewayUrl}/api/emails`;

	private _mailTemplates?: MailTemplateModel[];

	constructor(private readonly http: HttpClient, private pushService: PushService) {

		this.pushService.onChanges<any>(MessageType.MailTemplateChanges).subscribe(event => {
			this._mailTemplates = undefined;
		});
	}

	getMailTemplates(): Promise<MailTemplateModel[]> {
		if (this._mailTemplates) return new Promise((resolve) => { resolve(this._mailTemplates!) });
		return firstValueFrom(this.http.get<MailTemplateModel[]>(`${this.baseUrl}/mail-templates`)).then((mailTemplates: MailTemplateModel[]) => { this._mailTemplates = mailTemplates; return mailTemplates; });
	}

	getMailTemplate(id: string): Promise<MailTemplateModel> {
		return firstValueFrom(this.http.get<MailTemplateModel>(`${this.baseUrl}/mail-templates/${id}`));
	}

	deleteMailTemplate(id: string): Promise<void> {
		return firstValueFrom(this.http.delete<void>(`${this.baseUrl}/mail-templates/${id}`));
	}

	saveMailTemplate(mailTemplate: MailTemplateModel): Promise<MailTemplateModel> {
		return firstValueFrom(this.http.post<MailTemplateModel>(`${this.baseUrl}/mail-templates`, mailTemplate));
	}
}
